import React from "react";
import { Link } from "react-router-dom";
import { PageShell, EditableSection, EditableFeatureGrid } from "./PageShell";
import { ArrowRight, Sparkles } from "lucide-react";

const TIERS = [
  { badge: "Tier I", title: "Aperture", body: "Every new member. Earn 1 point per $1 spent. Access to seasonal launches, a birthday sample, and periodic private offers." },
  { badge: "Tier II", title: "Signature", body: "Unlocked at 500 points earned in a calendar year. Includes complimentary shipping on every order and early access to new editions." },
  { badge: "Tier III", title: "Maison", body: "Unlocked at 1,500 points earned in a calendar year. Adds a curated annual gift, first access to limited drops, and priority concierge response." },
];

const REWARDS = [
  { badge: "Points", title: "Earn 1 point per $1", body: "Points accrue automatically at checkout. Redeem at 500 points for a complimentary 10ml pure-oil roll-on." },
  { badge: "Early access", title: "Society-first launches", body: "New editions open to Society members before general release." },
  { badge: "Birthday", title: "A gift on us", body: "A complimentary discovery sample on your birthday, chosen to match your wardrobe." },
  { badge: "Referrals", title: "Share the scent", body: "Both you and your friend receive a $15 credit when they place their first order using your referral link." },
];

const HOW = [{
  heading: "How the Society works",
  body: "There is nothing to buy and nothing to sign up for beyond creating a Scentodore account. Every purchase counts toward your annual points total, tiers refresh with the calendar year, and points can be redeemed at checkout on any future order.",
}];

const FINE_PRINT = [{
  heading: "Fine print",
  body: "Points cannot be redeemed for cash and are non-transferable. Points expire 24 months after the order that earned them. Tier benefits may be adjusted over time as the programme evolves — members will be notified in advance of any change that materially affects them.",
}];

export default function LoyaltyPage() {
  return (
    <PageShell
      slug="loyalty"
      testid="loyalty"
      eyebrow="The Scentodore Society"
      title="Rewards for the way you wear Scentodore."
      intro="Not a discount club — a quiet acknowledgement that you’ve made scent part of your everyday impression. Points, private launches, and considered gifts."
    >
      <div className="mb-14 flex items-center gap-2 text-[10px] uppercase tracking-[0.2em] text-[#C5A059]">
        <Sparkles className="h-3 w-3" />
        <span>Free to join with any Scentodore account</span>
      </div>

      <EditableSection slug="loyalty" sectionKey="how" fallback={HOW} />

      <div className="mb-14">
        <h2 className="font-serif text-xl sm:text-2xl text-[#1A1918] mb-4">Tiers</h2>
        <EditableFeatureGrid slug="loyalty" sectionKey="tiers" fallback={TIERS} />
      </div>

      <div className="mb-14">
        <h2 className="font-serif text-xl sm:text-2xl text-[#1A1918] mb-4">Ways to be rewarded</h2>
        <EditableFeatureGrid slug="loyalty" sectionKey="rewards" fallback={REWARDS} />
      </div>

      <EditableSection slug="loyalty" sectionKey="fine_print" fallback={FINE_PRINT} />

      <div className="-mt-8 flex flex-wrap gap-3">
        <Link
          to="/register"
          data-testid="loyalty-signup-cta"
          className="inline-flex items-center gap-2 bg-[#1A1918] text-[#FAF8F5] px-5 py-3 rounded-xl text-xs uppercase tracking-[0.18em] hover:bg-[#C5A059] hover:text-[#0B0A08] transition-colors"
        >
          Join the Society <ArrowRight className="h-4 w-4" />
        </Link>
        <Link
          to="/account"
          data-testid="loyalty-account-cta"
          className="inline-flex items-center gap-2 border border-[#1A1918]/20 text-[#1A1918] px-5 py-3 rounded-xl text-xs uppercase tracking-[0.18em] hover:border-[#C5A059] hover:text-[#C5A059] transition-colors"
        >
          Your points balance
        </Link>
      </div>
    </PageShell>
  );
}
